import { formatToSF } from '@/bundles/GroupFilters/helpers/formatters/formatToSF';
import { formatDate } from '@/utils/filters';
import { Nullable } from '@/utils/types';
import { ITextValue } from '@/types/common';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { IUseType } from '@/bundles/UseType/types';

export enum ComparableCustomFieldsEnum {
  use_types = 'use_types',
  bts = 'bts',
  office_size = 'office_size',
  schedule_name = 'schedule_name',
  // building
  building_class = 'building_class',
  construction_status = 'construction_status',
  date_built_estimated = 'date_built_estimated',
  floor_count = 'floor_count',
  floor_plate = 'floor_plate',
  sprinkler = 'sprinkler',
  units = 'units',
  // loading doors
  cross_docked = 'cross_docked',
  shared_truck_court = 'shared_truck_court',
  // parking
  covered = 'covered',
  uncovered = 'uncovered',
  ratio = 'ratio',
}

export const getCustomFieldValue = (comparable, customField: Nullable<ComparableCustomFieldsEnum>) => {
  try {
    switch (customField) {
      case ComparableCustomFieldsEnum.use_types:
        return comparable.use_types.map((item: IUseType) => item.text).join(', ');
      case ComparableCustomFieldsEnum.bts:
        return comparable.transaction.bts;
      case ComparableCustomFieldsEnum.office_size:
        return isValuePresent(comparable.transaction.office_space) ? formatToSF(comparable.transaction.office_space) : null;
      case ComparableCustomFieldsEnum.schedule_name:
        return comparable.rent_schedule.name;
      case ComparableCustomFieldsEnum.building_class:
        return comparable.property.building.class;
      case ComparableCustomFieldsEnum.construction_status:
        return comparable.property.building.construction_status;
      case ComparableCustomFieldsEnum.date_built_estimated:
        return isValuePresent(comparable.property.building.date_built_estimated) ? formatDate(comparable.property.building.date_built_estimated) : null;
      case ComparableCustomFieldsEnum.floor_count:
        return comparable.property.building.floor_count;
      case ComparableCustomFieldsEnum.floor_plate:
        return isValuePresent(comparable.property.building.floor_plate) ? formatToSF(comparable.property.building.floor_plate) : null;
      case ComparableCustomFieldsEnum.sprinkler:
        return comparable.property.building.sprinkler;
      case ComparableCustomFieldsEnum.units:
        return comparable.property.building.units;
      case ComparableCustomFieldsEnum.cross_docked:
        return comparable.property.loading_doors.cross_docked;
      case ComparableCustomFieldsEnum.shared_truck_court:
        return comparable.property.loading_doors.shared_truck_court;
      case ComparableCustomFieldsEnum.covered:
        return comparable.property.parking.covered;
      case ComparableCustomFieldsEnum.uncovered:
        return comparable.property.parking.uncovered;
      case ComparableCustomFieldsEnum.ratio:
        return comparable.property.parking.ratio;
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const getComparableCustomFieldItems = (): ITextValue<ComparableCustomFieldsEnum>[] => [
  { text: 'Use Types', value: ComparableCustomFieldsEnum.use_types },
  { text: 'BTS', value: ComparableCustomFieldsEnum.bts },
  { text: 'Office Size', value: ComparableCustomFieldsEnum.office_size },
  { text: 'Rent Schedule Name', value: ComparableCustomFieldsEnum.schedule_name },
  { text: 'Building Class', value: ComparableCustomFieldsEnum.building_class },
  { text: 'Construction Status', value: ComparableCustomFieldsEnum.construction_status },
  { text: 'Building Date Built (Est.)', value: ComparableCustomFieldsEnum.date_built_estimated },
  { text: 'Floor Count', value: ComparableCustomFieldsEnum.floor_count },
  { text: 'Floor Plate', value: ComparableCustomFieldsEnum.floor_plate },
  { text: 'Sprinkler', value: ComparableCustomFieldsEnum.sprinkler },
  { text: 'Units', value: ComparableCustomFieldsEnum.units },
  { text: 'Cross Docked', value: ComparableCustomFieldsEnum.cross_docked },
  { text: 'Shared Truck Court', value: ComparableCustomFieldsEnum.shared_truck_court },
  { text: 'Parking Covered', value: ComparableCustomFieldsEnum.covered },
  { text: 'Parking Uncovered', value: ComparableCustomFieldsEnum.uncovered },
  { text: 'Parking Ratio', value: ComparableCustomFieldsEnum.ratio },
];
